import { navigate } from 'gatsby';
import { useEffect } from 'react';

export default function useRedirect(to = '/') {
  useEffect(() => {
    navigate(to);
  }, [to]);
}
